import * as requestFromServer from "./crud";
import {productsSlice, callTypes} from "./slices";
import {convertFilter} from "../../../utils/commonUtils";

const {actions} = productsSlice;

export const fetchProducts = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const _filter = convertFilter(queryParams);

  return requestFromServer
    .getProductList(_filter)
    .then(response => {
      const {pageInfo: {totalCnt}, goodsList} = response;
      dispatch(actions.productsFetched({totalCnt, goodsList}));
    })
    .catch(error => {
      error.clientMessage = "Can't find products";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchProduct = id => dispatch => {
  if (!id) {
    return dispatch(actions.productFetched({product: undefined}));
  }

  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .getProductById(id)
    .then(response => {
      const product = response;
      dispatch(actions.productFetched({product: product}));
    })
    .catch(error => {
      error.clientMessage = "Can't find product";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};
